const MsToTime = (val: string) => {
	const ms = parseInt(val, 10)
	const seconds = Number((ms / 1000).toFixed(1))
	const minutes = Number((ms / (1000 * 60)).toFixed(1))
	const hours = Number((ms / (1000 * 60 * 60)).toFixed(1))
	const days = (ms / (1000 * 60 * 60 * 24)).toFixed(1)
	if (seconds < 60) return `${seconds} Sec`
	if (minutes < 60) return `${minutes} Min`
	if (hours < 24) return `${hours} Hrs`
	return `${days} Days`
}

export default MsToTime
